<!--
  OaAvatar —— 帶 v-auth-img 能力的頭像元件（view-design <Avatar> 的 drop-in 代替）

  <img>/<Avatar> 無法直接帶自訂請求頭。此元件用 fetchAuthImg 以 axios 帶
  Authorization / X-TENANT-ID 取得圖片 blob，再交給內部的 <Avatar> 顯示。
  size / shape / class / style / 具名或預設 slot（縮寫、icon 等 fallback）全部透傳，
  行為與原 <Avatar> 一致，只是多了 auth 取圖 + 快取 / 去重 / LRU。

  用法：
    當前團隊頭像： <OaAvatar :src="item.avatar" size="large"> {{ $substrName(item.fullName) }} </OaAvatar>
    指定 tenantId（團隊列表每列不同團隊各自隔離）： <OaAvatar :src="row.logo" :tenant-id="row.id" />
-->
<template>
  <Avatar v-bind="$attrs" :src="blobSrc" v-on="$listeners">
    <slot />
  </Avatar>
</template>

<script>
import { fetchAuthImg } from '@/plugins/directives/auth-img';

export default {
  name: 'OaAvatar',
  // class / style 由 Vue 自動合併到根節點；其餘（size / shape 等）透過 $attrs 透傳
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      default: ''
    },
    // 指定 X-TENANT-ID，省略時用當前 localStorage 的 teamId
    tenantId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      blobSrc: '' // 帶 header 取得的 blob URL；空字串時 <Avatar> 會顯示 slot（縮寫 / icon）
    };
  },
  watch: {
    src: {
      immediate: true,
      handler: 'load'
    },
    tenantId() {
      this.load();
    }
  },
  methods: {
    async load() {
      const url = this.src;
      if (!url) {
        this.blobSrc = '';
        return;
      }
      // 用 token 防競態：src / tenantId 期間又變了就不覆蓋
      const token = `${url}::${this.tenantId || ''}`;
      this._loadToken = token;
      try {
        const tid = this.tenantId != null ? String(this.tenantId) : undefined;
        const blob = await fetchAuthImg(url, tid);
        // eslint-disable-next-line require-atomic-updates
        if (this._loadToken === token) this.blobSrc = blob;
      } catch (e) {
        // eslint-disable-next-line require-atomic-updates
        if (this._loadToken === token) this.blobSrc = ''; // 失敗回退顯示 slot
      }
    }
  }
};
</script>
